import { render } from "./RollingBanner.vue?vue&type=template&id=2b1c1ca0&scoped=true"
import script from "./RollingBanner.vue?vue&type=script&lang=js"
export * from "./RollingBanner.vue?vue&type=script&lang=js"

import "./RollingBanner.vue?vue&type=style&index=0&id=2b1c1ca0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1c1ca0"]])

export default __exports__